import type { User } from "@/generated/graphql";

export enum ContestType {
  Raffle = "Raffle",
  Quiz = "Quiz",
}

export type IContestFinished = {
  winner: User;
  title: string | null;
  translations: string[];
  created_by_id: string | null;
  prize: {
    id: string;
    title: string | null;
    image: string | null;
    translations: string[];
  };
  end_time: string;
  type: ContestType;
};
